export const CONTROL_FORM_FIELDS = {
    CHANGEEMPLOYEEID: {
        EMPLOYEEIDINPUT: 'employeeidinput',
    },
    CREATESHIFTS: {
        TEMPLATENAME: 'templateName',
        SHIFTTYPE: 'shiftType',
        STARTTIME: 'startTime',
        ENDTIME: 'endTime',
        DURATIONMINUTES: 'durationMinutes',
        COLORCODE: 'colorCode',
        ISOVERNIGHT: 'isOvernight',
        ISACTIVE: 'isActive',
        BREAKS: 'breaks',
        BREAKSTART: 'breakStart',
        BREAKEND: 'breakEnd',
        BREAKDURATION: 'breakDurationMinutes',
        ISPAID: 'isPaid',
    },
    EMPLALERTS: {
        COMMENTS: 'Comments',
    },
}